import Mustache from 'mustache';
import elevatedContainer from './generic/elevatedContainer';
import FormV10 from './v10/form/form-v10';
import { getToken } from './cmtoken';

const fields = ['firstname', 'lastname', 'email', 'phone', 'accept_conditions[]'];

/**
 * IncomingCarNotificationForm element
 */
export class IncomingCarNotificationForm {

  /**
   * Hand picked DOM -elements that are accessed multiple times
   * during form live time.
   */
  #elements = {};

  /**
   * @param {HTMLElement} element incoming car notification form
   */
  constructor(element) {
    this.element = element;
    this.#elements.form = element.querySelector('form');
    this.#elements.thankYouView = element.querySelector('.thankyouview');
    this.#elements.errorsContainer = element.querySelector('.errors-container');
    this.#elements.errorsContainerMessage = element.querySelector('.form-v10__error-message');
    this.#elements.form.addEventListener('submit', this.onSubmit.bind(this));
    this.showThankYouView(false);
  }

  /**
   *  @param {HTMLElement} source source element, something like a car card button
   */
  set sourceElement(source) {
    this.#elements.source = source;
  }

  /**
   * Called on form submit event
   * @param {SubmitEvent} event submit event
   */
  async onSubmit(event) {
    event.preventDefault();

    try {
      const token = await getToken();

      const notification = {
        token: token,
        license: this.#elements.source.dataset.license
      };

      fields.forEach( field => {
        if(this.#elements.form[field].type === 'checkbox') {
          notification[field] = this.#elements.form[field].checked;
        } else {
          notification[field] = this.#elements.form[field].value;
        }
      });

      const response = await fetch('/stage-ajax/incoming-car-notification', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(notification)
      });

      const {validation} = await response.json();

      fields.forEach( fieldName => {
        if( this.#elements.form[fieldName].type !== 'hidden' ) {
          const field = this.#elements.form[fieldName].closest('.form-v10__field');
          FormV10.showFieldValidation( field, validation.success[fieldName], validation?.errors?.[fieldName] )
        }
      });

      // Extra error cases can be handled here
      if( validation?.errors?.duplicates ) {
        const errorsMessage = '{{#errors}}<p>{{.}}</p>{{/errors}}';
        const html = Mustache.render( errorsMessage, { errors: [ validation.errors.duplicates ] });
        this.#elements.errorsContainerMessage.innerHTML = html;
      }

      this.#elements.errorsContainer.classList.toggle('hidden',!validation?.errors?.duplicates )

      if(!validation.errors) {
        this.showThankYouView(true);
      }

    } catch( error ) {
      console.log(error);
    }
  }

  /**
   * After form is submitted and a notification is stored to database user has shown a
   * message that tells that everything is okey.
   * @param {boolean} show show or hide thank you view
   */
  showThankYouView(show) {
    this.#elements.form.classList.toggle('hidden', show);
    this.#elements.thankYouView.classList.toggle('hidden', !show);
  }

  /**
   * Hide errors after user opens new notification. In a case user whant to notification from multiple
   * car.
   */
  hideValidationErrors() {
    fields.forEach( fieldName => {
      if( this.#elements.form[fieldName].type !== 'hidden' ) {
        const field = this.#elements.form[fieldName].closest('.form-v10__field');
        FormV10.showFieldValidation( field, false, false );
      }
    });
    this.#elements.errorsContainer.classList.toggle('hidden', true);
  }

  /**
   * Initialize IncomingCarNotificationForm modals when a button is pressed.
   */
  static init() {
    const incomingCarNotificationFormElement = document.querySelector('.incoming-car-notification-form-modal');

    if( incomingCarNotificationFormElement ) {
      const incomingCarNotificationForm = new IncomingCarNotificationForm(incomingCarNotificationFormElement);

      document.addEventListener('click', (event) => {
        const {target} = event;
        if(target.tagName === 'BUTTON' && target.dataset.license && target.dataset.modalTarget === 'incoming-car-notification') {
          elevatedContainer.toggleVisibility(incomingCarNotificationFormElement, true);
          incomingCarNotificationForm.sourceElement = target;
          incomingCarNotificationForm.showThankYouView(false);
          incomingCarNotificationForm.hideValidationErrors();
        }
      });
    }
  }
}

